import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

/** Mounted once inside the router. When any upload is refused with 413 storage_full, one calm toast with a way forward (not one per file). */
export default function StorageFullNotice() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const last = useRef(0);
  useEffect(() => {
    const on = (e: Event) => {
      const now = Date.now();
      if (now - last.current < 8_000) return;
      last.current = now;
      const d = (e as CustomEvent<{ plus?: boolean; trialAvailable?: boolean }>).detail ?? {};
      const plus = !!d.plus;
      // Only offer SK Plus to someone who can actually start it. After the trial there is nothing to buy yet, so the way forward is freeing space.
      const offer = !plus && !!d.trialAvailable;
      toast.error(plus ? t("plus.full.plusTitle") : t("plus.full.freeTitle"), {
        description: plus ? t("plus.full.plusBody") : offer ? t("plus.full.freeBody") : t("plus.full.freeNoTrialBody"),
        duration: 9_000,
        action: { label: offer ? t("plus.full.cta") : t("plus.full.manage"), onClick: () => navigate("/plus") }
      });
    };
    window.addEventListener("sk:storage-full", on);
    return () => window.removeEventListener("sk:storage-full", on);
  }, [navigate, t]);
  return null;
}
